/**
 * A chapter's footer: Back · Show me on my plan · Next (Finish on the last).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import type { DropGenPlanDetail } from '@trafficpulse/shared';

import type { ChapterBridge } from '../tutorial-chapters';
import { TutorialBridge, type BridgeParams } from './TutorialBridge';

const NAV =
  'inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-40';

export const ChapterFooter: FC<{
  n: number;
  total: number;
  bridge: ChapterBridge | null;
  plan: DropGenPlanDetail;
  onPrev: () => void;
  onNext: () => void;
  onBridge: (params: BridgeParams) => void;
}> = ({ n, total, bridge, plan, onPrev, onNext, onBridge }) => (
  <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-border/60 pt-3">
    <button type="button" className={NAV} onClick={onPrev} disabled={n === 1}>
      <ChevronLeft className="h-3.5 w-3.5" /> Back
    </button>
    {bridge ? <TutorialBridge bridge={bridge} plan={plan} onBridge={onBridge} /> : null}
    <span className="grow" />
    <button type="button" className={NAV} onClick={onNext}>
      {n === total ? 'Finish' : 'Next'} <ChevronRight className="h-3.5 w-3.5" />
    </button>
  </div>
);
